import './styles/easy-admin.scss';
import './styles/bootstrap.scss';
import './styles/admin.scss';

import '../js/jquery-global';

import "select2";
import "datatables.net-dt";

import "./js/components";
import "../js/form/validation";
import "../js/form/attributes";
import "./js/cms/menu";
import "./js/cms/page-struct";
import "./js/cms/contentbuilder";
import "./js/cms/create-modal";
